import { getMessages } from '../../../../../../store/constants';

export const COLLABORATOR_TOOLTIP_TITLE = getMessages().getText('user_tooltip.collaborators.title');
export const COLLABORATOR_TOOLTIP_TITLE_SINGLE = getMessages().getText('user_tooltip.collaborators.title_single');
